import { useContext } from 'react';
import type WaveSurfer from 'wavesurfer.js';
import { createNamedContext } from '@/utils';

export const WaveSurferContext = createNamedContext<WaveSurfer>(undefined, 'WaveSurferContext');

export const useWaveSurferContext = () => useContext(WaveSurferContext);